import * as React from 'react';
import isEqual from 'lodash/isEqual';

function useInfinitePageLength(searchState, pageSize) {
    var ref;
    const previousSearchStateRef = React.useRef(searchState);
    const lengthFromState = parseInt((ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.length, 10);
    const [length, setLength] = React.useState(lengthFromState || pageSize);
    const setLengthCallback = React.useCallback(()=>{
        setLength(length + pageSize);
    }, [
        length,
        pageSize
    ]);
    React.useEffect(()=>{
        const { refinementList , range  } = previousSearchStateRef.current;
        if (length !== pageSize && (!isEqual(refinementList, searchState.refinementList) || !isEqual(range, searchState.range))) {
            // reset page size when a refinements are mutated
            setLength(pageSize);
            if (searchState.configure) {
                searchState.configure.offset = 0;
                searchState.configure.length = pageSize;
                searchState.configure.page = 1;
            }
        }
        previousSearchStateRef.current = searchState;
    }, [
        JSON.stringify(searchState),
        length,
        pageSize
    ]);
    return [
        length,
        setLengthCallback
    ];
}

export { useInfinitePageLength };
//# sourceMappingURL=use-infinite-page-length.js.map
